import { DOMNode, domToReact } from 'html-react-parser'

import Link from 'app/components/base/Link'
import ReactHtmlParser from 'app/components/base/ReactHtmlParser'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text, { TextProps } from 'app/components/base/Text'

const replaceWithHighlightKeyword = (
  node: DOMNode & { name?: string; children?: DOMNode[] },
  variant: TextProps['variant']
) => {
  if (node.type === 'tag' && node?.name === 'mark') {
    const keywords = node?.children as DOMNode[]

    return (
      <Text
        variant={variant}
        sx={{ display: 'inline-flex', backgroundColor: '#FFEF5B', px: 0.25 }}
      >
        {domToReact(keywords)}
      </Text>
    )
  }

  return node
}

interface SearchResultCardProps {
  title: string
  link: string
  preview: string
  isLoading: boolean
  isLastItem?: boolean
}

const SearchResultCard = ({
  title,
  link,
  preview,
  isLoading,
  isLastItem
}: SearchResultCardProps) => {
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ ...(!isLastItem && { pb: 3 }) }}
    >
      <Skeleton loading={isLoading} sx={{ width: '60%', height: 24 }}>
        <Link href={link} variant="h3">
          <ReactHtmlParser
            data={title}
            options={{
              replace: (node) => replaceWithHighlightKeyword(node, 'h3')
            }}
          />
        </Link>
      </Skeleton>

      <Skeleton loading={isLoading} sx={{ width: '100%', height: 24 }}>
        <Text variant="body1" lineClamp={2} sx={{ wordBreak: 'break-word' }}>
          <ReactHtmlParser
            data={preview}
            options={{
              replace: (node) => replaceWithHighlightKeyword(node, 'body1')
            }}
          />
        </Text>
      </Skeleton>
    </Stack>
  )
}

export default SearchResultCard
